export default "/images/flag-ru.png?800e15abc77cf30523dff72c56cd6ca1";